module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daniel Woodrell, Dennis Lehane\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Five of "), _c('B', [_vm._v("Daniel Woodrell")]), _vm._v("'s published novels were selected as "), _c('I', [_vm._v("New York Times")]), _vm._v(" Notable Books of the Year. "), _c('I', [_vm._v("Tomato Red")]), _vm._v(" won the PEN West Award for the Novel in 1999. Woodrell lives in the Ozarks near the Arkansas line with his wife, Katie Estill.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/J17p6S/tc-custom/9780316206150.jpg?1736423609721",
      "alt": "This image is the cover for the book Death of Sweet Mister"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Death of Sweet Mister\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("Winter's Bone ")]), _vm._v("delivers “a terrifying journey into the heart of darkness” with this suspenseful coming of age tale set in the Ozarks ("), _c('i', [_vm._v("The New York Times Book Review")]), _vm._v(").")])]), _c('p', [_vm._v("Shug Akins is a lonely, overweight thirteen-year-old boy. His mother, Glenda, is the one person who loves him—she calls him Sweet Mister and attempts to boost his confidence and give him hope for his future. Shuggie's purported father, Red, is a brutal man with a short fuse who mocks and despises the boy. ")]), _c('p', [_vm._v("Into this small-town Ozarks mix comes Jimmy Vin Pearce, with his shiny green T-bird and his smart city clothes. When he and Glenda begin a torrid affair, a series of violent events is inevitably set in motion. The outcome will break your heart."), _c('br'), _c('br'), _c('b', [_vm._v("“This is Daniel Woodrell's third book set in the Ozarks and, like the other two, ")]), _c('i', [_c('b', [_vm._v("Give Us a Kiss")])]), _c('b', [_vm._v(" and ")]), _c('i', [_c('b', [_vm._v("Tomato Red")])]), _c('b', [_vm._v(", it peels back the layers from lives already made bare by poverty and petty crime” —Otto Penzler, Penzler Pick, 2001")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0